// Subscription states the renewal and retry jobs still select, mirroring
// Subscriptions::SubscriptionActions::DUNNING_STATES on the API.
const DUNNING_STATES = [
  'inactive_no_card',
  'inactive_invalid_card',
  'inactive_failed',
];

// Which "when should this take effect" options a tier change may offer.
//
// Shared by the confirmation view, which renders the choice, and its parent, which has to know
// whether any valid choice exists before it enables Confirm.
function resolveEffectiveDateOptions(subscription) {
  // A positive retainer bank means the patient is still owed retainers they have already paid for.
  // Charging today and shipping again on top of that is the churn vector closed in
  // _docs/features/free-trial-system.md, so "Now" is withheld.
  const hasPositiveRetainerBank = subscription?.patient?.retainerBank > 0;

  // "On renewal" cannot work once the renewal is already overdue: there is no future renewal to
  // start the new plan on, and the backend refuses it (RENEWAL_PAST_DUE_ERROR) because the
  // replacement it would build lands outside every renewal and retry job scope.
  const renewalPastDue =
    DUNNING_STATES.includes(subscription?.state) &&
    Boolean(subscription?.renewalAt) &&
    new Date(subscription.renewalAt) <= new Date();

  const canChooseNow = !hasPositiveRetainerBank;
  const canChooseOnRenewal = !renewalPastDue;

  return {
    canChooseNow,
    canChooseOnRenewal,
    renewalPastDue,
    // A renewing subscription has already shipped its quota, so its retainer bank should be back
    // to 0 by the time it renews - the renewal order is what credits it again. Both gates firing
    // at once therefore means that invariant has been broken upstream. Rather than render an empty
    // chooser, the view says so and points the customer at someone who can fix it.
    hasNoEffectiveDateOption: !(canChooseNow || canChooseOnRenewal),
  };
}

export { DUNNING_STATES, resolveEffectiveDateOptions };
